import invoicing from './invoicing'

export default [
  ...invoicing,
]
